export const routeName = 'selection-criteria';
export const slugs: Record<string, string> = {
	es: 'criterios-de-seleccion',
	en: 'selection-criteria',
	ca: 'criteris-de-seleccio',
	fr: 'criteres-de-selection',
	it: 'criteri-di-selezione',
};
export const sitemap = { changefreq: 'monthly', priority: '0.6', lastmod: '2026-09-02' };
